import * as React from 'react'

import { getTagConfigBySliceType } from 'components/MCTextEditor/formatting/constants'
import { SliceType } from 'components/MCTextEditor/slice/types'
import SmartLinks from 'components/MCTextEditor/smartLinks/components/SmartLinks'
import Url from 'components/MCTextEditor/url/components/Url'
import Variable from 'components/MCTextEditor/variables/components/Variable'
import VariableInput from 'components/MCTextEditor/variables/components/VariableInput'
import { WithEditorContext } from 'components/RichTextEditor/EditorContext'
import { ISlice } from 'components/RichTextEditor/processor/constants'
import { isRangeAIncludesB, shrinkRange } from 'components/RichTextEditor/processor/range'
import { IEditorContext } from 'components/RichTextEditor/types'

import MCEditorContext from '../MCEditorContext'

interface ISliceProps extends IEditorContext {
  slice: ISlice
  children?: React.ReactNode
}

const Slice = (props: ISliceProps) => {
  const { processor, slice, children } = props

  const { readonly } = React.useContext(MCEditorContext)

  const selection = processor.getSelection()

  const tagConfig = getTagConfigBySliceType(slice.type)
  if (tagConfig) {
    const Comp = tagConfig.sliceComponent
    return <Comp {...props} />
  }

  switch (slice.type) {
    case SliceType.VARIABLE: {
      const isSelected = selection.length === 0 && selection.start === slice.range.start + 1
      return <Variable {...props} isSelected={isSelected && !readonly} />
    }
    case SliceType.VARIABLE_INPUT: {
      return <VariableInput {...props} />
    }
    case SliceType.URL: {
      const isSelected = isRangeAIncludesB(shrinkRange(slice.range), selection)
      return (
        <Url {...props} isSelected={isSelected && !readonly}>
          {children}
        </Url>
      )
    }
    case SliceType.SMART_LINK: {
      const isSelected = isRangeAIncludesB(shrinkRange(slice.range), selection)
      return <SmartLinks {...props} isSelected={isSelected && !readonly} />
    }

    default:
      return null
  }
}

export default WithEditorContext<ISliceProps>(Slice)
